export default {
  Model: {},
  Actions: {
    FETCH_HOME_PAGE_DATA_SUCCESS: 'home_page/FETCH_HOME_PAGE_DATA_SUCCESS',
  },
  State: {},
};
